

import React from 'react';


import { Layout,Input,Select,Radio,Form, Cascader} from 'element-react';
import { Button,Switch } from '@jd/find-react';
 
import 'element-theme-default';
import KeeVue from '../base/KeeVue.js'

import FsView from '../render/FsView.js'
import FsJsonConfig from './FsJsonConfig.js'

import $ from 'jquery';

import { Tabs } from '@jd/find-react';

const { TabPane } = Tabs;
export default class FsComponentPropertyRight extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				randId: this.getRandString(),
				targetComponent: null,
				keeVueComponents: [],
				style: {
					left: 0,
					top: 0,
					width: '100%',
					height: '100%',
				 
				},
				isShowPageConfig: false,
				styleCommonField: null,
				startPoint: {
					isMouseDown: false,
					x: 0,
					y: 0,
					left: 0,
					top: 0,
				},
				showPropertyFlag: false,
				isshowDirect: false,
				appOptions: [],
				toMovePage: null,
				selectValue: '',
				showWinName: 'exchange',
				allPages: '',
				activeRightTab: 'r1',
				propsConfig: {
					value: 'id',
					label: 'text',
					children: 'children',
					expandTrigger: 'hover'
				},
				pageOptions:[],
				cascaderValue:'',
				permissionOptions:[],
				permissionValue:[],
				activeComponent:{},
				selectComponent:{},
				updateVersion:0,
				options:[],
			};

}

		componentDidMount(){
			let that = this;
			this.doRequest("/keeVueComponent/listData?search_EQ_isActive=1&search_EQ_isDel=0&order=asc&sort=seq&fields=name,title,icon,type,isActive,seq,formConfigJson,isContainer,functions,events,", function(ret) {
				if(ret.rows !== null) {
					if(ret.rows !== null) {
						for(let i = 0; i < ret.rows.length; i++) {
							let t = ret.rows[i];
							if(t.events ) {
								//console.log(t.events);
								t.events = JSON.parse(t.events);
							} else {
								t.events = [];
							}
						}
					}
					that.state.keeVueComponents = ret.rows;
					that.setState(that.state);
				}
			});
			this.doRequest("/keeVueApp/getAppConfig?title=common-component-prop-form&name=form", function(formField) {
				that.state.styleCommonField = formField;
			});

			this.doRequest("/front/getAllPermissions?appName="+window.appName, (ret)=> {
				that.state.permissionOptions = ret;
				this.refresh();
			} );
			
			if(!window.isReport)
			{
				this.getAllTableList();
			}
			
			this.onEvent("updateAllTableList",this.getAllTableList);




			 // this.onEvent("showComponentProperty2", this.onRightClick);
			 
			  this.onEvent("showComponentProperty2", this.onUpdateComponentProperty);
			 this.onEvent("updateComponentProperty2", this.onUpdateComponentProperty);
			this.onEvent("clearSelectState", function() {
				 that.state.targetComponent = null;
				 that.state.permissionValue = [];

				that.state.showPropertyFlag = false;
				that.setState(that.state);
			})
			this.onEvent("drag.select", this.onDragSelect);
			// this.onEvent("right.showPageConfig", this.onShowPageConfig);
			this.onEvent("right.showCreatePage", this.onShowCreatePage);
			this.onEvent("right.exchange", this.onExchange);
			
			this.onEvent("showCustomSource",(action)=>{
				// alert(JSON.stringify(action));
				this.showEventSource(action ,this.props.targetComponent)
			})
			
			this.onEvent("selectTableName",(options)=>{
				this.state.options = options;
				this.refresh();
				// alert("shuax xinx"+JSON.stringify(options));
			})
		
			
			
			$("body").on("mouseup", function() {
				that.state.startPoint.isMouseDown = false;
			});

		}

			onMouseDown=()=> {
				//$("body").on("mousemove", this.onmousemove);
			}
			changeRightTab=(tab)=> {
				// console.log("=====================");
				// console.log(tab.props.name);
				//alert("tab.name="+tab.props.name);
				 this.state.activeRightTab = tab;
				console.log("this.state.activeRightTab:"+this.state.activeRightTab);
				this.setState(this.state);
			}
			//响应用户切换组件的动作
			onUpdateComponentProperty=(event, selectComponent)=> {
				 console.log("gengxin========onUpdateComponentProperty")
				this.state.selectComponent = selectComponent;
			 
					
				// 	this.refresh();
				// 	this.firstOpen = false;
				// 	return ;
				// }
				  this.state.showPropertyFlag = true
				this.showWindow();
				//if(this.state.showPropertyFlag === true)
				 
					let that = this;

					

					  // console.log(" selectComponent.permission:"+selectComponent.id+selectComponent.name+ selectComponent.permission);
					if(selectComponent)
					{
						this.state.permissionValue = [];
					}
					 if(selectComponent&&selectComponent.permission)
					 {
						
					 	this.state.permissionValue = selectComponent.permission.split(",");
					 }
					 
				//alert("111111this.props.keePage.config.entity:"+this.props.keePage.config.entity);
				
				if(this.props.keePage.config.entity) 
				{
					this.doRequest("/mainFrame/getTableJson?tableName="+this.props.keePage.config.entity,(ret)=>{
							     
							     if(ret)
							     {
							          
							         let fields = JSON.parse(ret.fieldJson);
							         
							         let options = [];
							         
							         for(let i=0;i<fields.length;i++)
							         {
							             options.push({
							                 "value":fields[i].name,
							                 "label":(fields[i].name+"("+fields[i].comment+")"),
											 "title":fields[i].comment,
							             })
							         }
							         //alert("sssss"+JSON.stringify(options));
							         this.sendEvent("selectTableName",options);
							       
							         
							     }
							     else
							     {
							         alert("获取表结构信息失败！");
							     }
							     
							 })
				}
			

					 this.setState(this.state);
				 
			}
		 
			onmousemove=(event)=> {

				let state = JSON.parse(JSON.stringify(this.state));
				let that = this;
				let target = this.currentDom;
				if(target !== null) {
					 
					if(state.startPoint.x === 0 && state.targetComponent !== null && $("#" + state.targetComponent.id) !== null && $("#" + state.targetComponent.id).offset() !== null && this.props.controller.showSource === false) {
						let left0 = parseInt($("#" + state.targetComponent.id).offset().left);
						let top0 = parseInt($("#" + state.targetComponent.id).offset().top);
						let width = parseInt($("#" + state.targetComponent.id).width());
						let totalWidth = $("body").width();
						let totalHeight = document.documentElement.clientHeight;
						if((totalWidth - left0 - 30) < 310) {
							state.style.left = (totalWidth - 310) + "px";
						} else {
							state.style.left = (left0 + 30) + "px";
						}
						if(totalHeight - top0 < 610) {
							state.style.top = (totalHeight - 610) + "px";
						} else {
							state.style.top = (top0 + 10) + "px";
						}
						state.style.width = "400px";
						state.style.height = "600px";
						
					}
				}
				if(state.startPoint.isMouseDown === true) {
					let left = state.startPoint.left + (event.clientX - state.startPoint.x);
					let top = state.startPoint.top + (event.clientY - state.startPoint.y);
					let totalWidth = $("body").width();
					let totalHeight = document.documentElement.clientHeight;
					if((totalWidth - left) < 310) {
						state.style.left = (totalWidth - 310) + "px";
					} else {
						state.style.left = (left) + "px";
					}
					if(totalHeight - top < 610&&totalHeight - 610>10) {
						state.style.top = (totalHeight - 610) + "px";
					} else {
						state.style.top = (top) + "px";
					}
				}

				this.setState({style:state.style});
			}
			onTitleMousedown=(event)=> {
// 				let state = JSON.parse(JSON.stringify(this.state));
// 				state.startPoint.isMouseDown = true;
// 				console.log("启动")
// 				state.startPoint.x = event.clientX;
// 				state.startPoint.y = event.clientY;
// 				state.startPoint.left = parseInt(state.style.left.replace("px", ""));
// 				state.startPoint.top = parseInt(state.style.top.replace("px", ""));
// // $("body").on("mousemove", this.onmousemove);
// this.setState(state);
			}
			onStopEvent=()=> {
			}
			showWindow=()=>{
				let showDiv =  (this.state.showPropertyFlag===true||this.state.isShowPageConfig===true)&& this.props.controller.showSource == false &&(this.props.targetComponent!==null||this.state.isShowPageConfig===true);
				
				//this.state.style.display = showDiv?'block':'none';
				
			}
			closePageForm=()=> {
				this.state.isShowPageConfig = false;
				this.state.showPropertyFlag = false;
				this.showWindow();
				this.setState(this.state);
			}
			createNewPage=()=>{
			this.sendEvent("createNewPageByPage",this.cascaderValue);
			}
			onShowCreatePage=(item, pages)=> {
				let totalWidth = $("body").width();
				let totalHeight = document.documentElement.clientHeight;
				this.state.style.left = (totalWidth / 2 - 250) + "px";
				this.state.style.top = (totalHeight * 0.15) + "px";
				this.state.style.width = "550px";
				this.state.style.height = "450px";
				this.state.isShowPageConfig = true;
				this.showWinName = "createNewPage";
				this.state.allPages = pages;
				let that = this;
				this.cascaderValue = "";
				
				this.showWindow();
				
				this.doRequest("/jdccApp/listTreeOptions?dictTypeName=clientType_PC&rootUri=&",function(ret){
					that.cascaderValue = ret;
				});
			}
			onShowPageConfig=(item, pages)=> {
				let totalWidth = $("body").width();
				let totalHeight = document.documentElement.clientHeight;
				this.state.style.left = (totalWidth / 2 - 250) + "px";
				this.state.style.top = (totalHeight * 0.15) + "px";
				this.state.style.width = "550px";
				this.state.style.height = "450px";
				this.state.isShowPageConfig = true;
				if(item.keePage.config.background===null)
				{
					this.setVueAttr(item.keePage.config,"background","");
				}
				this.state.toMovePage = item;
				console.log(JSON.stringify(item))
				this.showWinName = "config";
				this.state.allPages = pages;
				this.showWindow();
			}
			onChangeHuabuType=(value)=> {
				if(value === "full") {
					this.props.keePage.config.width = "1000px";
					this.props.keePage.config.height = "1200px";
				}
				if(value === "dialog") {
					this.props.keePage.config.width = "700px";
					this.props.keePage.config.height = "400px";
				}
				if(value === "mobile") {
					this.props.keePage.config.width = "450px";
					this.props.keePage.config.height = "900px";
				}
				this.sendEvent("changePageType");
			}
			onChangePageType=(item)=> {
				this.sendEvent("changePageType");
			}
			onChangeBackground=()=>{
				this.sendEvent("changeBackground",this.props.keePage);
			}
			onCheckCode=()=> {
				if(this.state.allPages !== null) {
					for(let i = 0; i < this.state.allPages.length; i++) {
						if(this.state.allPages[i].keePage.code === this.props.keePage.code && this.state.allPages[i].keePage.id !== this.props.keePage.id) {
							this.showErrorMessage("页面代码重复，请重新输入");
							this.props.keePage.code = this.props.keePage.id;
							break;
						}
					}
				}
			}
			onExchange=(item)=> {
				let that = this;
				let totalWidth = $("body").width();
				let totalHeight = document.documentElement.clientHeight;
				this.state.style.left = (totalWidth / 2 - 250) + "px";
				this.state.style.top = (totalHeight * 0.15) + "px";
				this.state.style.width = "500px";
				this.state.style.height = "400px";
				this.state.toMovePage = item;
				this.doRequest("/jdccApp/listData?search_EQ_isDel=0&search_NOTEQ_id=" + window.appId + "&fields=name,title", function(ret) {
					that.state.appOptions = ret.rows;
				})
				this.state.isShowPageConfig = true;
				this.showWinName = "exchange";
			}
			movePage=()=> {
				let that = this;
				if(this.state.toMovePage !== null) {
					if(this.isNotBlank(this.selectValue)) {
						this.doRequest("/keePage/exchangeAppPage", function(ret) {
							if(ret.success === true) {
								this.showMessage(ret);
								that.sendEvent("exchanged", that.state.toMovePage);
								that.isShowPageConfig = false;
								that.state.toMovePage = null;
							} else {
								this.showMessage(ret);
							}
						}, {
							pageId: this.props.keePage.id,
							appId: this.selectValue
						});
					} else {
						this.showErrorMessage("请选择一个应用！")
					}
				}
			}
			createNewCol=()=> {
				let that = this;
				let component = this.props.targetComponent;
				this.doRequest("/keeVueComponent/getByName?name=fs-table-col", function(ret) {
					if(ret !== null && ret.id !== null) {
						let c = $.extend({
							style: $.extend({}, {
								display: 'block',
							}),
							cp: {},
							alias: this.getRandString(), // 别名
							value: ''
						}, ret, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
						c.isSelected = false;
							c.isKeeShowBorder = false;
							 c.isMouseOver=false;
						this.doRequest("/keeVueApp/getAppConfig?title=fs-table-col-prop-form&name=form", function(data) {
							that.initComponentByFormField(c, data);
							if(that.state.styleCommonField !== null) {
								that.initComponentByFormField(c, that.state.styleCommonField);
							}
							component.child.splice(0, 0, c);
							that.refreshComponent.bind(that)();
								that.sendEvent("createState");
						});
					}

				});
			}
			createNewTabItem=()=> {
				let that = this;
				let component = this.props.targetComponent;
				this.doRequest("/keeVueComponent/getByName?name=fs-tabs-item", function(ret) {
					if(ret !== null && ret.id !== null) {
						let c = $.extend({
							style: $.extend({}, {
								display: 'block',
							}),
							cp: {},
							alias: this.getRandString(), // 别名
							value: ''
						}, ret, {
							id: this.getRandString(),
							rect: {
								x: 0,
								y: 0,
								w: 0,
								h: 0,
							},
							child: [], // 这个很重要，必须要，否则检测不到变化
						});
						if(that.debug === true) {
							for(let i = 0; i < 10000000; i++) {
								let alias = this.props.keePage.config.alias + ".tabItem" + i;
								if(!that.isAliasExists(this.props.components, alias)) {
									c.alias = alias;
									break;
								}
							}
						}
						c.isSelected = false;
						c.isKeeShowBorder = false;
						c.visiable = true;
						c.isMouseOver=false;
						this.doRequest("/keeVueApp/getAppConfig?title=fs-tabs-item-prop-form&name=form", function(data) {
							that.initComponentByFormField(c, data);
							that.initComponentByFormField(c, that.state.styleCommonField);
							c.cp.name = this.getRandString();
							c.cp.title = "标签";
							if(this.isNotBlank(that.activeName) !== true) {
								that.activeName = c.cp.name;
							}
							setTimeout(function() {
								that.sendEvent("key.down");
							}, 10);
							component.child.push(c);

							that.refreshComponent.bind(that)();
								this.sendEvent("createState");
						});
					}


				});
			}
			onDragSelect=(event, isShowDom)=> {}
			propFormFieldChange=(item, formData)=> {
				let that = this;
				// this.sendEvent("propFormFieldChange");
				console.log("收到页面变更事件")
				//这个只有socket开启才有效
				this.sendEvent("changedComponents");
				this.sendEvent(this.props.po.id+".reload",formData);
				
				this.refresh();
				// if(formData.name === 'fs-table-col') {
				
				// }
			}
			pageFieldChange=()=> {
				this.sendEvent("pageFieldChange")
			}
			showEventSource=(ev, component)=> {
				this.props.controller.showSource = true;
				
				this.props.controller.showCenterPage = "source";
				 
				
				let sourceCodeStr = window.editor.getValue();
				if(sourceCodeStr.indexOf("on_" + component.alias + "." + ev.eventName) === -1) {
					let start = sourceCodeStr.indexOf("{");
					if(start === -1) {
						sourceCodeStr = " \n\n let crudExt = {\n\n}";
						sourceCodeStr += "\n\n\n\ ";
					}
					start = sourceCodeStr.indexOf("{");
					if(start !== -1) {
						let newFunction = "\n\t\"on_" + component.alias + "." + ev.eventName + "\" : function(" + ev.eventParas + "){\n\t\t alert('响应事件：" + component.alias + "." + ev.eventName + "') \n\t},\n";
						sourceCodeStr = sourceCodeStr.substring(0, start + 1) + "\n\t" + newFunction + "\t\t" + sourceCodeStr.substring(start + 1);
						window.editor.setValue(sourceCodeStr);
					}
				}
				// 通知顶层组件重绘
				this.sendEvent("redraw");
				this.refresh();

				if(this.yanshiTime)
				{
					this.yanshiTime = 300;
				}
				else
				{
					this.yanshiTime=1000;
				} 
				for(let tt=1;tt<=3;tt++)
				{
					setTimeout(()=> {
						window.editor.find("on_" + component.alias + "." + ev.eventName, {
							backwards: false,
							wrap: false,
							caseSensitive: false,
							wholeWord: false,
							regExp: false
						});
						window.editor.findNext();
						window.editor.findPrevious();
					
					}, tt*200);
				}
				
			}
			changed=()=> {}
			valueChange=(item)=>{}

		changePermission=(selectValue)=>{

			if(this.state.selectComponent &&this.props.targetComponent!==null )
			{
				//console.log("selectComponent.permission: shezhi："+this.state.selectComponent.id);
				this.state.selectComponent.permission = selectValue.join(",");
				this.state.permissionValue = [];

					 // //console.log(" selectComponent.permission:"+ selectComponent.permission);

					 if(this.state.selectComponent&&this.state.selectComponent.permission)
					 {
					 	this.state.permissionValue = this.state.selectComponent.permission.split(",");
					 }
				this.setState(  this.state);

				//console.log("权限选中值："+JSON.stringify(selectValue)+this.props.targetComponent.permission )
			}


		}
		
		componentWillReceiveProps(nextProps){
			
			 
		
			
			// if(JSON.stringify(this.props.po)!==JSON.stringify(nextProps.po))
			// {
			// 		this.state.showPropertyFlag = true;
			// 	console.log("sssssssssssssssssssss");
			// 	this.state.selectComponent = nextProps.po;
			// 	 this.refresh();
			// }
		}
		
		onPageConfigCommand=(type,value)=>{
			// 通知出全局事件
			this.sendEvent("changePageType")
		}
		
		showComponentJsonPage=()=> {
			 
			  this.sendEvent("showComponentJsonPage"); 
		}
		
		getAllTableList=()=>{
			this.doRequest("/resMysql/listAllTable", (ret)=>{
				if(ret){
					this.allDbModelList = ret;
				}
				else
				{
					this.allDbModelList = []
				}
			})
		}
		
		showActionDlg=(ev,component)=>{
			
			let exists = false;
			
			let actions = this.props.targetComponent.actions;
		 
		 for(let i=0;i<actions.length;i++)
		 {
			 if(actions[i].eventName==ev.eventName)
			 {
				 exists = true;
			 }
		 }
		 
	 
		 if(!exists)
		 {
			 //alert("bu cunzai  yao tianjia ")
			 actions.push({
				 id:this.getRandString(),
				 key:this.getRandString(),
				 eventName:ev.eventName, 
			 })
		 }
		 this.refresh();
		 
		}
		

  render(){
	   
	  this.pageList=[];
	  window.appPages.map((item,index)=>{
		  this.pageList.push({
			  title:item.title,
			  value:item.code,
		  })
	  });
	  
	  let cols=[];
	  for(let i=1;i<=24;i++)
	  {
	  	cols.push(i);
	  }
	  
	 // alert(JSON.stringify(this.props.keePage.tableFileds));

	 // console.log("面板组件的po::"+JSON.stringify(this.props.po));

	  let showDiv =  (this.state.showPropertyFlag===true||this.state.isShowPageConfig===true)   &&(this.props.targetComponent||this.state.isShowPageConfig===true);

		if(this.props.targetComponent)
		{
			if(typeof this.props.targetComponent.actions=='undefined')
			{
				this.props.targetComponent.actions=[];
			}
		}
 

	 // if(showDiv)
	  {

		  return( <div   style={{padding:'5px'}} > <div id={this.state.randId} className={`kee-fs-component-property-right`}   style={this.state.style }   >

			  {  
				  this.props.targetComponent&&this.props.targetComponent.id&&<div style={{display:(showDiv?'block':'none'),width:' 100%',height:' 100%',position:' relative'}} >
		              <div className="jdcc-disable-select" style={{position:' relative',top:' 0',left:' 0',right:' 0',height:' 40px'}} onMouseDown={this.onMouseDown} >
		                   
		                  <div style={{fontSize:'18px ',lineHeight:'36px',paddingLeft:'5px',fontWeight:' bold',width:'100%',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}} 
						      onMouseDown={this.onTitleMousedown} >

		  						{this.props.targetComponent.title}- {this.props.targetComponent.alias} 

		                  </div>
		              </div>
		              <div className={`build-left-tab jdcc-disable-select`} style={{  top:' 40px',left:' 20px',right:' 0'}} >
		                   
						  <Tabs defaultActiveKey="r1" onChange={this.changeRightTab}>
						      <TabPane tab="组件" key="r1">
						        
						      </TabPane>
						      <TabPane tab="样式" key="r2">
						       
						      </TabPane>
						      <TabPane tab="动作" key="r3">
						       
						      </TabPane>
						   </Tabs>
		              </div>
		              <div   style={{display:(this.state.activeRightTab==='r1'?'block':'none'), top:' 89px',left:' 0',right:' 0',bottom:' 0', overflow:' auto'}} >
		                  <div style={{width:' 100%', lineHeight:'30px',paddingLeft:'8px', background:' #F2f2f2',color:'rgb(0,0,0,.65)',margingTop:'30px'}} >
		                  事件
		                  </div>

		                      {
		  						this.props.targetComponent&&<div style={{padding:'8px 0'}}>
		  						{

		  						  this.state.keeVueComponents.map((com,index)=>{

		  							  if(this.props.targetComponent.name==com.name)
		  							  {

		  							  	   return com.events.map((ev,ii)=>{
		  							  											 if(ev.eventName)
		  							  											 {
		  							  											 return <Button size="small" style={{margin:'4px'}}   key={ii}   onClick={()=>this.showEventSource(ev,this.props.targetComponent)} >
		  							  													{ev.eventName}
		  							  											 </Button>
		  							  											 }
		  							  									});
		  							  }
									  else
									  return '';
		  						  })

		  						}
		  					</div>
		  					}


		                  <div style={{width:' 100%', lineHeight:'30px', paddingLeft:'8px', background:' #F2f2f2',color:'rgb(0,0,0,.65)'}} >
		                  操作
		                  </div>
						  {
							  this.props.targetComponent.name==='fs-table'&& <div  >
							      <Button size="mini"  style={{margin:'8px'}}  type="primary" onClick={this.createNewCol} >
							      添加列
							      </Button>
							  </div>
						  }
						  {
							  this.props.targetComponent.name==='fs-tabs'&&  <div   >
							      <Button size="mini" style={{margin:'8px'}}  type="primary" onClick={this.createNewTabItem} >
							      添加列
							      </Button>
							  </div>
						  }


		                  <div style={{width:' 100%', lineHeight:'30px', paddingLeft:'8px',background:' #F2f2f2',color:'rgb(0,0,0,.65)'}} >
		                  属性
		                  </div>
		                  <div style={{padding:' 8px 0px 0px 0px'}} className={`fsComponentProperty`} >
		                      <Form label-position={'right'} >
		                          <div >
		                              <Layout.Row >
		                                  <Layout.Col span={24} >
		                                      <Form.Item label="组件标识" labelWidth="70px" >
		                                          <Input size="small" value={this.props.targetComponent.alias} 
												  onChange={(newValue)=>{  
													  
													   
													  if(!this.props.targetComponent.oldAlias)
													  {
														  this.props.targetComponent.oldAlias=this.props.targetComponent.alias;
													  }
													  let oldAlias = this.props.targetComponent.oldAlias;
													  
													  let viewName = this.props.targetComponent.viewName;
													  
													  if(!window.CMap[ viewName][this.props.targetComponent.id])
													  	{
													  		window.CMap[ viewName][this.props.targetComponent.id] = window.CMap[viewName][oldAlias];
													  	}
														
														// 判断是否和props里面的key冲突
														
														let propKeys =  window.CMap[ viewName].$options._propKeys;
														
														for(let i=0;i<propKeys.length;i++)
														{
															if(propKeys[i]==newValue)
															{ 
															    window.showErrorMessage("与系统属性冲突");
																this.props.targetComponent.alias=newValue.trim();   
																this.setState(this.state);
																return ;
															}
														}
													  
													  // 要判断这个新的组件标识是否与已有的对象冲突！
													  // window.showErrorMessage(oldAlias+"==="+newValue+"::"+viewName);
													  if(oldAlias!=newValue&&window.CMap[ viewName][newValue])
													  {
														  //如果这个已经存在，则不能赋予这个值
														  window.showErrorMessage("唯一标识冲突，"+newValue+",请重新输入")
														  
													  }
													  else
													  {
														  // if(oldAlias!=newValue&&window.CMap[viewName][oldAlias]&&newValue&&!window.CMap[viewName][newValue])
														  // {
														  	  
														  	
														  // 	window.CMap[ viewName][newValue] = 	window.CMap[ viewName][this.props.targetComponent.id];
														  // 	delete 	window.CMap[viewName][oldAlias];
														  																	 
														  	 
														  // }
													  }
													  
													 
													  
													  
													   this.props.targetComponent.alias=newValue.trim();
													  
													  
													   this.setState(this.state)
													   }
													   }
												  onBlur={
													  (newValue)=>{
														  
														  if(newValue)
														  {
															  // 返回的是一个对象，value需要提取出来
															  newValue = newValue.target.value.trim();
														  }
														  if(!this.props.targetComponent.oldAlias)
														  {
														  	  this.props.targetComponent.oldAlias=this.props.targetComponent.alias;
														  }
														  let oldAlias = this.props.targetComponent.oldAlias;
														   
														  if(!newValue)
														  {
															  window.showErrorMessage("组件标识不能为空字符串");
															  newValue =oldAlias;
															  this.props.targetComponent.alias = newValue;
														  }
														  
														 
														  
														  let viewName = this.props.targetComponent.viewName;
														  
														
														  
														  // 判断是否和props里面的key冲突
														  
														  let propKeys =  window.CMap[ viewName].$options._propKeys;
														  
														  for(let i=0;i<propKeys.length;i++)
														  {
															  if(propKeys[i]==newValue)
															  {
																  newValue=newValue+1;
																  window.showErrorMessage("与系统属性冲突，自动重命名");
																  break;
															  }
														  }
														  // 要判断这个新的组件标识是否与已有的对象冲突！
														  let thisZuJian = window.CMap[ viewName][newValue];
														  
														 while(thisZuJian&&(!thisZuJian.component||thisZuJian.component.id!==this.props.targetComponent.id))
														  {
														  	   //如果这个已经存在，改为一个随机数
															   newValue=newValue+1;
															   thisZuJian = window.CMap[ viewName][newValue];
														  }
														  //  要更新一下，后面需要用到
														   this.props.targetComponent.alias = newValue;
													
														   this.setState(this.state);
														   
														   if(newValue==oldAlias)
														   {
														   	 return ;
														   }
														  
														    console.log("alias变更："+newValue+",old:::"+this.props.targetComponent.alias)
														     this.sendEvent("checkAliasOlny",newValue,(ret)=>{
																 
																 // 需要重新注册
																console.log("使用新的alias："+ret);
																
																let oldAlias = this.props.targetComponent.oldAlias;
																let viewName = this.props.targetComponent.viewName;
																if(oldAlias!=ret&&window.CMap[viewName][this.props.targetComponent.id]&&ret&&!window.CMap[ viewName][ret])
																{
																	
																	window.CMap[ viewName][ret] = 	window.CMap[viewName][this.props.targetComponent.id];
																	delete 	window.CMap[viewName][this.props.targetComponent.id];
																	delete 	window.CMap[viewName][oldAlias];
																																	 
																	this.props.targetComponent.alias=ret;
																	
																	this.props.targetComponent.oldAlias = ret;
																	this.setState(this.state)}
																}
																
													  			  )}}
													   >
		                                          </Input>
		                                      </Form.Item>
		                                  </Layout.Col>
		                              </Layout.Row>
									  <Layout.Row style={{marginTop:'4px'}} >
									      <Layout.Col span={24} >
										   <Form.Item label="绑定字段" labelWidth="70px" >
										   <div className={`rightCommonForm`}>
										   <Select style={{'width':'100%'}} type="primary" 
										   defaultValue={''}
										   value={this.state.selectComponent&&this.state.selectComponent.cp?this.state.selectComponent.cp.field:''}
										   allowClear={true}
											  onChange={(sv)=>{
												  if(this.state.selectComponent.cp)
												  {
													  this.state.selectComponent.cp.field=sv;
													  for(let i=0;i<this.state.options.length;i++)
													  {
													  	  if(this.state.options[i].value===sv)
													  		 {
													  		  this.state.selectComponent.cp.title=this.state.options[i].title;
													  		  break;
													  		}
													  }
												  }
												  
												  this.sendEvent("refreshTitleAndField",this.state.selectComponent.id);
												
											  
											  this.refresh();}}  >
										   {
										   	this.state.options.map((item,index)=>{
										   		return <Select.Option   key={item.value+index} label={item.value} value={item.value} >
												<div style={{'padding':'5px 0','width':'198px'}}>
													{item.value}<br/>
													{item.title}
												</div>
												</Select.Option>
										   	})
										   }
										   </Select>
										   </div>
										    </Form.Item>
										</Layout.Col>
									  </Layout.Row>	  
									  
									  
									  <Layout.Row style={{marginTop:'4px'}} >
									      <Layout.Col span={24} >
									  			 <Form.Item label="列宽" labelWidth="70px" >
									  				<div  >
									  				<Select style={{'width':'100%'}} type="primary" 
									  					 
									  					value={this.props.targetComponent?this.props.targetComponent.cp.span2:''}
														allowClear={true}
									  					onChange={(sv)=>{
															 
														 window.setVueAttr(this.props.targetComponent.cp,"span2",sv);
														 
															
															//this.props.targetComponent.cp.span2=sv;
														this.props.targetComponent.cp.span=sv;
														this.refresh();}}  >
									  					{
															cols.map((item,index)=>{
									  						 return <Select.Option  
															 key={item+index} label={item} value={item} >{item} </Select.Option>
									  					  })
									  					 }
									  				</Select>
									  				  </div>
									  			 </Form.Item>
									  		 </Layout.Col>
									  </Layout.Row>	
									  
									  <Layout.Row >
									      <Layout.Col span={24} >
									          <Form.Item label="过滤器" labelWidth="70px" >
									              <Input size="small" value={this.props.targetComponent.cp.filter} 
									  												  onChange={(newValue)=>{   
									  													  this.props.targetComponent.cp.filter=newValue;
									  													   this.setState(this.state)}}
									  												   
									  													   >
									              </Input>
									          </Form.Item>
									      </Layout.Col>
									  </Layout.Row>
									  
									  
		                              <Layout.Row style={{marginTop:'4px'}} >
		                                  <Layout.Col span={24} >
		                                      <Form.Item label="需要权限" labelWidth="70px" >
		                                          {
		  										/*	<KeeFormInputSelect form={this.props.targetComponent} field="permission" type="many" url="/front/getAllPermissions" >
		  											</KeeFormInputSelect>*/
		  										}

												<Select style={{'width':'100%'}} type="primary" value={this.state.permissionValue} multiple={true} onChange={(sv)=>{if(showDiv){return this.changePermission(sv)}}}  >
												{
													this.state.permissionOptions.map((item,index)=>{
														return <Select.Option style={{'marginLeft':'10px'}} key={item.value+index} label={item.title} value={item.value} ></Select.Option>
													})
												}
												</Select>
		                                      </Form.Item>
		                                  </Layout.Col>
		                              </Layout.Row>
									  <Layout.Row style={{marginTop:'4px'}} >
									      <Layout.Col span={24} >
									          <Form.Item label="是否显示" labelWidth="70px" >
											  
												 <Switch size="small"  
												 checked={this.props.targetComponent.cp.visiable!=false} 
												 onChange={(checked)=>{
													 window.setVueAttr(this.props.targetComponent,"visiable",checked);
													 window.setVueAttr(this.props.targetComponent,"cp.visiable",checked);
													 
													 this.props.targetComponent.cp.visiable = checked;
													 this.props.targetComponent.visiable = checked;
													 this.setState(  this.state);
												 }}/>
									           
									          </Form.Item>
									      </Layout.Col>
									  </Layout.Row>
									  
									  <Layout.Row style={{marginTop:'4px'}} >
									      <Layout.Col span={24} >
									          <Form.Item label="是否禁用" labelWidth="70px" >
									  											  
									  												 <Switch size="small"  
									  												 checked={this.props.targetComponent.cp.disabled===true} 
									  												 onChange={(checked)=>{ 
									  													 window.setVueAttr(this.props.targetComponent,"cp.disabled",checked); 
									  													 this.props.targetComponent.cp.disabled = checked; 
									  													 this.setState(  this.state);
									  												 }}/>
									           
									          </Form.Item>
									      </Layout.Col>
									  </Layout.Row>
									  
		                          </div>
		                      </Form>
		                  </div>
						  
		                 {
		  				  <FsView url={'M::vueComponentProp_'+this.props.targetComponent.name+'/'+this.props.targetComponent.name+'-prop-form'} 
						  keePage={this.props.keePage}  
						   po={this.state.selectComponent} 
						  showVueMode={true}
						   debug={false} 
						   keepAlive={true} 
						   isMouseMove={this.state.startPoint.isMouseDown}
						   onChanged={this.propFormFieldChange}
							onCommand={this.propFormFieldChange}>
		  				  </FsView>
		  			     }
		              </div>
		              {  this.props.targetComponent&& <div  style={{'display':(this.state.activeRightTab==='r2'?'block':'none'),position:' static',top:' 83px',left:' 0',right:' 0',bottom:' 0', overflow:' auto'}} >
		                   {
		  					   <FsView url={'M::vueComponentProp/common-component-prop-form'}
								po={this.state.selectComponent}
								 showVueMode={true}
								isMouseMove={this.state.startPoint.isMouseDown}
								keePage={this.props.keePage}  
								debug={false}
								keepAlive={true} >
		  					    </FsView>
		  				   }
		                  </div>
		              }
					  {
						 /* <Button type="primary" size="default"   onClick={()=>{this.openBottomPage("M::adminDbModel/tableList&id=",{});}} >数据模型</Button>*/
						  
					  }
					  {  
						<div  style={{'display':(this.state.activeRightTab==='r3'?'block':'none'),position:' static',top:' 83px',left:' 0',right:' 0',bottom:' 0', overflow:' auto'}} >
					        
							<div style={{fontWeight:500,fontSize:'16px',lineHeight:'40px'}}>
								选择触发事件
							</div>
					        {
					        	this.props.targetComponent&&<div style={{padding:'8px 0'}}>
					        	{
					        
					        	  this.state.keeVueComponents.map((com,index)=>{
					        
					        		  if(this.props.targetComponent.name==com.name)
					        		  {
					        
					        		  	   return com.events.map((ev,ii)=>{
					        		  			if(ev.eventName)
					        		  			{
					        		  				return <Button size="small" style={{margin:'4px'}}   key={ii} 
													  onClick={()=>this.showActionDlg(ev,this.props.targetComponent)} >
					        		  													{ev.eventName}
					        		  				</Button>
					        		  			}
					        		  		});
					        		  }
					        		  else
					        		  return '';
					        	  })
					        
					        	}
					        </div>
					        }
							
							<div style={{fontWeight:500,fontSize:'16px',lineHeight:'40px'}}>
								动作配置
							</div>
							
							{
													  this.props.targetComponent.actions.map((action,index)=>{
														 
														 return <div key={action.id}>
															<div style={{height:'30px',background:'#e5e5e5',lineHeight:'30px',borderRadius:'4px',paddingLeft:'8px'}}>{action.eventName}
															<div style={{'float':'right',marginRight:'8px'}}>   
																				 
							      		  	<i className={`el-icon-delete`} style={{cursor:'pointer'}} onClick={()=>{this.props.targetComponent.actions.remove(action);this.refresh()}} ></i>
																					 
							      		</div>
															</div>
															<div style={{marginLeft:'-10px'}}>
																<FsView url={'M::jdccApp/actionManager'}
																								po={action}
																								updateVersion={this.state.updateVersion}
																								isMouseMove={this.state.startPoint.isMouseDown}
																								keePage={this.props.keePage}  
																								debug={false}
																								showVueMode={true}
																								
																								minHeight="100px"
																								parameters={{action:action,
																								pageList:this.pageList,
																								apiList:this.apiList,
																								allDbModelList:this.allDbModelList}}
																								keepAlive={true} >
																 </FsView>
															</div>
														 </div>
														  
													  })
							}
					      </div>
					  }
					  
					  
					  
					  
					  
		          </div>
			  }

 

		  	{
		  		   <div style={{display:( (showDiv)?'none':'block')}} >
				    
					{
						/*<div   style={{width:'100%',height:'80px','paddingTop':'15px',textAlign:'center'}} >
						    <Button type="primary" size="mini"   onClick={this.showComponentJsonPage} >JSON</Button>
						     &nbsp;&nbsp;&nbsp;&nbsp;
						    <Button type="primary" size="mini" onClick={this.changeBackground} >
						    背景
						    </Button>
						</div>*/
					}
					
					
					<div style={{fontSize:'18px',lineHeight:'36px',paddingBottom:'16px',paddingLeft:'5px'}}>
						页面参数配置
					</div>
					
				 
		  		    <FsView url={'M::jdccApp/pageConfigForm'}
		  		    								po={this.props.keePage} 
		  		    								keePage={this.props.keePage}  
		  		    								debug={false}
													showVueMode={true}
		  		    								keepAlive={true}   onCommand={this.onPageConfigCommand}>
		  		     </FsView>
					 
		  		</div>
		  	}
 
			</div>
		  </div>
		    );
	  }

	  return "";
}
 }

